import { Toast } from 'mint-ui'
export default {
    name: 'max',
    config: {},
    install(Vue, installOptions) {
        Vue.directive('max', (el, binding, vnode) => {
            let max = binding.value || 9999
            let handler = function(e) {
                var validateId = e.target.getAttribute('validate-id')
                if (!validateId) {
                    validateId = uuid()
                    e.target.setAttribute('validate-id', validateId)
                }
                if (e.target.value > max) {
                    e.target.value = max
                    vnode.elm.dispatchEvent(new CustomEvent('input'))
                    var title = e.target.getAttribute('title')
                    var msg = `${title || '输入值'}不能大于${max}`
                    if (vnode.context.errors && vnode.context.errors.filter(x => x.id == validateId && x.type == 'max').length == 0) {
                        vnode.context.errors.push({ id: validateId, type: 'max', msg: msg })
                    }
                    Toast(msg)
                } else {
                    vnode.context.errors = vnode.context.errors && vnode.context.errors.filter(x => !(x.id == validateId && x.type == 'max'))
                }
            }
            el.addEventListener('input', handler)
        })
    }
}

function uuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}


// WEBPACK FOOTER //
// ./src/directive/max.js